import React from "react";
import Toolbar from "@mui/material/Toolbar";
import { NavLink } from "react-router-dom";
import { createStyles, makeStyles } from "@mui/styles";

import { ProSidebar, Menu, MenuItem, SubMenu, SidebarHeader, SidebarContent } from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import Box from "@mui/material/Box";
import "./Sidenav.css";

import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import AuthService from "../../service/auth";
import { setPermission, setUser } from "../../store/actions";

const useStyles = makeStyles((theme) =>
  createStyles({
    imageList: {
      background: "#f5f9fc",
      "& > .pro-inner-item": {
        color: "#16192c !important",
        "&:hover": {
          color: "#16192c !important"
        },
        "& > .pro-arrow-wrapper .pro-arrow": {
          borderColor: "#16192c !important"
        }
      }
    },
    img: {
      width: "150px",
    },
    img_min: {
      width: "30px",
    },
  })
);

const Sidenav = ({ open, sidenavItems, toggleDrawer, userDetails }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logout = async () => {
    const authService = new AuthService();
    await authService.logout();
    dispatch(setUser(null));
    dispatch(setPermission([]));
    navigate((userDetails.currentUser && (userDetails.currentUser.isAdminOrEmp === 1 || userDetails.currentUser.Role_id === 4)) ? "/admin" : "/");
  };

  const handleMenuItemClick = (funcName) => {
    if (funcName === "logout") logout();
  };

  return (
    <ProSidebar
      breakPoint="md"
      style={{ zIndex: 1202, height: "100vh" }}
      collapsed={!open}
      toggled={open}
      onToggle={toggleDrawer}
      width="240px"
    >
      <SidebarHeader>
        <Toolbar
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            px: [1],
          }}
        >
          <Box
            className="site-logo"
            sx={{
              flex: "1",
              ...(!open && { marginLeft: "17px" }),
            }}
          >
            <Box className="icon-logo">
              <img src={window.location.origin + '/images/icon-logo.svg'}/>
            </Box>
            <Box className="full-logo">
              <img src={window.location.origin + '/images/logo.svg'}/>
            </Box>

          </Box>
        </Toolbar>
      </SidebarHeader>

      <SidebarContent>
        <Menu style={{ paddingTop: "10px" }}>
          {sidenavItems.map(({ id, title, icon, image, navigateTo, externalLink, onClickFunc, children, active }, index) => (
            <Box key={index}>
              {children && (
                <Menu style={{ padding: 0, lineHeight: !open ? "55px" : "15px" }}>
                  <SubMenu
                    title={title}
                    icon={
                      open ? (
                        icon ? (
                          icon
                        ) : (
                          image
                        )
                      ) : (
                        <Box>
                          <Box sx={{ lineHeight: "15px" }}>{icon}</Box>
                          <Box
                            sx={{
                              fontSize: "10px",
                              textAlign: "center",
                              lineHeight: "15px",
                            }}
                          >
                            {title}
                          </Box>
                        </Box>
                      )
                    }
                    className={
                      children.some((el) => el.navigateTo === window.location.pathname) ? classes.imageList : ""
                    }
                  >
                    {children.map(({ id, title, icon, image, navigateTo }) => (
                      <MenuItem
                        key={id}
                        icon={icon ? icon : image}
                        className={window.location.pathname === navigateTo ? classes.imageList : ""}
                      >
                        {title}
                        <NavLink to={navigateTo}></NavLink>
                      </MenuItem>
                    ))}
                  </SubMenu>
                </Menu>
              )}

              {!children && (
                <MenuItem
                  key={id}
                  style={!open ? { lineHeight: "55px" } : { lineHeight: "15px" }}
                  icon={
                    open ? (
                      icon
                    ) : (
                      <Box>
                        <Box sx={{ lineHeight: "15px" }}>{icon}</Box>
                        <Box
                          sx={{
                            fontSize: "10px",
                            textAlign: "center",
                            lineHeight: "15px",
                          }}
                        >
                          {title}
                        </Box>
                      </Box>
                    )
                  }
                  className={window.location.pathname === navigateTo ? classes.imageList : ""}
                  onClick={() => onClickFunc && handleMenuItemClick(onClickFunc)}
                >
                  {title}
                  {
                    externalLink ? (
                      <a href={externalLink} target="_blank"></a>
                    ) : (
                      navigateTo && <NavLink to={navigateTo}></NavLink>
                    )
                  }
                </MenuItem>
              )}
            </Box>
          ))}
        </Menu>
      </SidebarContent>
    </ProSidebar>
  );
};

export default Sidenav;
